import tokens from '../tokens/js/tokens';
// Definition of the "notice" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
export const NOTICE_LIGHT_HARD_DEFAULT = {
    background: tokens.colors.yellow[400].value,
    border: tokens.colors.yellow[400].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Hard + Hover
export const NOTICE_LIGHT_HARD_HOVER = {
    background: tokens.colors.yellow[500].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[800].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Hard + Pressed
export const NOTICE_LIGHT_HARD_PRESSED = {
    background: tokens.colors.yellow[600].value,
    border: tokens.colors.yellow[600].value,
    foregroundAlt: tokens.colors.yellow[900].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Hard + Focus
export const NOTICE_LIGHT_HARD_FOCUS = {
    background: tokens.colors.yellow[400].value,
    border: tokens.colors.yellow[700].value,
    foregroundAlt: tokens.colors.yellow[900].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Hard + Disabled
export const NOTICE_LIGHT_HARD_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[150].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Soft + Default
export const NOTICE_LIGHT_SOFT_DEFAULT = {
    background: tokens.colors.yellow[200].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Soft + Hover
export const NOTICE_LIGHT_SOFT_HOVER = {
    background: tokens.colors.yellow[300].value,
    border: tokens.colors.yellow[600].value,
    foregroundAlt: tokens.colors.yellow[600].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Soft + Pressed
export const NOTICE_LIGHT_SOFT_PRESSED = {
    background: tokens.colors.yellow[400].value,
    border: tokens.colors.yellow[700].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Soft + Focus
export const NOTICE_LIGHT_SOFT_FOCUS = {
    background: tokens.colors.yellow[200].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Soft + Disabled
export const NOTICE_LIGHT_SOFT_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + White + Default
export const NOTICE_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[700].value
};
// Light + White + Hover
export const NOTICE_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: tokens.colors.yellow[700].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + White + Pressed
export const NOTICE_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Light + White + Focus
export const NOTICE_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[700].value
};
// Light + White + Disabled
export const NOTICE_LIGHT_WHITE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Ghost + Default
export const NOTICE_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[700].value
};
// Light + Ghost + Hover
export const NOTICE_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: tokens.colors.yellow[700].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[700].value
};
// Light + Ghost + Pressed
export const NOTICE_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Light + Ghost + Focus
export const NOTICE_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[700].value
};
// Light + Ghost + Disabled
export const NOTICE_LIGHT_GHOST_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Bare + Default
export const NOTICE_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[700].value
};
// Light + Bare + Hover
export const NOTICE_LIGHT_BARE_HOVER = {
    background: tokens.colors.yellow[150].value,
    border: tokens.colors.yellow[150].value,
    foregroundAlt: tokens.colors.yellow[600].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Bare + Pressed
export const NOTICE_LIGHT_BARE_PRESSED = {
    background: tokens.colors.yellow[200].value,
    border: tokens.colors.yellow[200].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[900].value
};
// Light + Bare + Focus
export const NOTICE_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[700].value
};
// Light + Bare + Disabled
export const NOTICE_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
export const NOTICE_DARK_HARD_DEFAULT = {
    background: tokens.colors.yellow[400].value,
    border: tokens.colors.yellow[400].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Hard + Hover
export const NOTICE_DARK_HARD_HOVER = {
    background: tokens.colors.yellow[500].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[800].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Hard + Pressed
export const NOTICE_DARK_HARD_PRESSED = {
    background: tokens.colors.yellow[600].value,
    border: tokens.colors.yellow[600].value,
    foregroundAlt: tokens.colors.yellow[900].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Hard + Focus
export const NOTICE_DARK_HARD_FOCUS = {
    background: tokens.colors.yellow[400].value,
    border: tokens.colors.yellow[400].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Hard + Disabled
export const NOTICE_DARK_HARD_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Soft + Default
export const NOTICE_DARK_SOFT_DEFAULT = {
    background: tokens.colors.yellow[200].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Soft + Hover
export const NOTICE_DARK_SOFT_HOVER = {
    background: tokens.colors.yellow[300].value,
    border: tokens.colors.yellow[600].value,
    foregroundAlt: tokens.colors.yellow[600].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Soft + Pressed
export const NOTICE_DARK_SOFT_PRESSED = {
    background: tokens.colors.yellow[400].value,
    border: tokens.colors.yellow[700].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Soft + Focus
export const NOTICE_DARK_SOFT_FOCUS = {
    background: tokens.colors.yellow[200].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[900].value
};
// Dark + Soft + Disabled
export const NOTICE_DARK_SOFT_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + White + Default
export const NOTICE_DARK_WHITE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Dark + White + Hover
export const NOTICE_DARK_WHITE_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[300].value,
    foregroundAlt: tokens.colors.yellow[300].value,
    foreground: tokens.colors.yellow[300].value
};
// Dark + White + Pressed
export const NOTICE_DARK_WHITE_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[700].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[700].value
};
// Dark + White + Focus
export const NOTICE_DARK_WHITE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Dark + White + Disabled
export const NOTICE_DARK_WHITE_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Ghost + Default
export const NOTICE_DARK_GHOST_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Dark + Ghost + Hover
export const NOTICE_DARK_GHOST_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[300].value,
    foregroundAlt: tokens.colors.yellow[300].value,
    foreground: tokens.colors.yellow[300].value
};
// Dark + Ghost + Pressed
export const NOTICE_DARK_GHOST_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[700].value,
    foregroundAlt: tokens.colors.yellow[700].value,
    foreground: tokens.colors.yellow[700].value
};
// Dark + Ghost + Focus
export const NOTICE_DARK_GHOST_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Dark + Ghost + Disabled
export const NOTICE_DARK_GHOST_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Bare + Default
export const NOTICE_DARK_BARE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Dark + Bare + Hover
export const NOTICE_DARK_BARE_HOVER = {
    background: tokens.colors.yellow[850].value,
    border: tokens.colors.yellow[850].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Dark + Bare + Pressed
export const NOTICE_DARK_BARE_PRESSED = {
    background: tokens.colors.yellow[900].value,
    border: tokens.colors.yellow[900].value,
    foregroundAlt: tokens.colors.yellow[300].value,
    foreground: tokens.colors.yellow[300].value
};
// Dark + Bare + Focus
export const NOTICE_DARK_BARE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.yellow[500].value,
    foregroundAlt: tokens.colors.yellow[500].value,
    foreground: tokens.colors.yellow[500].value
};
// Dark + Bare + Disabled
export const NOTICE_DARK_BARE_DISABLED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
export const NOTICE_LIGHT_HARD = {
    default: NOTICE_LIGHT_HARD_DEFAULT,
    disabled: NOTICE_LIGHT_HARD_DISABLED,
    focus: NOTICE_LIGHT_HARD_FOCUS,
    hover: NOTICE_LIGHT_HARD_HOVER,
    pressed: NOTICE_LIGHT_HARD_PRESSED
};
// Light + Soft
export const NOTICE_LIGHT_SOFT = {
    default: NOTICE_LIGHT_SOFT_DEFAULT,
    disabled: NOTICE_LIGHT_SOFT_DISABLED,
    focus: NOTICE_LIGHT_SOFT_FOCUS,
    hover: NOTICE_LIGHT_SOFT_HOVER,
    pressed: NOTICE_LIGHT_SOFT_PRESSED
};
// Light + White
export const NOTICE_LIGHT_WHITE = {
    default: NOTICE_LIGHT_WHITE_DEFAULT,
    disabled: NOTICE_LIGHT_WHITE_DISABLED,
    focus: NOTICE_LIGHT_WHITE_FOCUS,
    hover: NOTICE_LIGHT_WHITE_HOVER,
    pressed: NOTICE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
export const NOTICE_LIGHT_GHOST = {
    default: NOTICE_LIGHT_GHOST_DEFAULT,
    disabled: NOTICE_LIGHT_GHOST_DISABLED,
    focus: NOTICE_LIGHT_GHOST_FOCUS,
    hover: NOTICE_LIGHT_GHOST_HOVER,
    pressed: NOTICE_LIGHT_GHOST_PRESSED
};
// Light + Bare
export const NOTICE_LIGHT_BARE = {
    default: NOTICE_LIGHT_BARE_DEFAULT,
    disabled: NOTICE_LIGHT_BARE_DISABLED,
    focus: NOTICE_LIGHT_BARE_FOCUS,
    hover: NOTICE_LIGHT_BARE_HOVER,
    pressed: NOTICE_LIGHT_BARE_PRESSED
};
// Dark+ Hard
export const NOTICE_DARK_HARD = {
    default: NOTICE_DARK_HARD_DEFAULT,
    disabled: NOTICE_DARK_HARD_DISABLED,
    focus: NOTICE_DARK_HARD_FOCUS,
    hover: NOTICE_DARK_HARD_HOVER,
    pressed: NOTICE_DARK_HARD_PRESSED
};
// Dark+ Soft
export const NOTICE_DARK_SOFT = {
    default: NOTICE_DARK_SOFT_DEFAULT,
    disabled: NOTICE_DARK_SOFT_DISABLED,
    focus: NOTICE_DARK_SOFT_FOCUS,
    hover: NOTICE_DARK_SOFT_HOVER,
    pressed: NOTICE_DARK_SOFT_PRESSED
};
// Dark+ White
export const NOTICE_DARK_WHITE = {
    default: NOTICE_DARK_WHITE_DEFAULT,
    disabled: NOTICE_DARK_WHITE_DISABLED,
    focus: NOTICE_DARK_WHITE_FOCUS,
    hover: NOTICE_DARK_WHITE_HOVER,
    pressed: NOTICE_DARK_WHITE_PRESSED
};
// Dark + Ghost
export const NOTICE_DARK_GHOST = {
    default: NOTICE_DARK_GHOST_DEFAULT,
    disabled: NOTICE_DARK_GHOST_DISABLED,
    focus: NOTICE_DARK_GHOST_FOCUS,
    hover: NOTICE_DARK_GHOST_HOVER,
    pressed: NOTICE_DARK_GHOST_PRESSED
};
// Dark + BARE
export const NOTICE_DARK_BARE = {
    default: NOTICE_DARK_BARE_DEFAULT,
    disabled: NOTICE_DARK_BARE_DISABLED,
    focus: NOTICE_DARK_BARE_FOCUS,
    hover: NOTICE_DARK_BARE_HOVER,
    pressed: NOTICE_DARK_BARE_PRESSED
};
// Light
export const NOTICE_LIGHT = {
    bare: NOTICE_LIGHT_BARE,
    ghost: NOTICE_LIGHT_GHOST,
    hard: NOTICE_LIGHT_HARD,
    soft: NOTICE_LIGHT_SOFT,
    white: NOTICE_LIGHT_WHITE
};
// Dark
export const NOTICE_DARK = {
    bare: NOTICE_LIGHT_BARE,
    ghost: NOTICE_LIGHT_GHOST,
    hard: NOTICE_LIGHT_HARD,
    soft: NOTICE_LIGHT_SOFT,
    white: NOTICE_LIGHT_WHITE
};
// Color schema
const NOTICE = {
    dark: NOTICE_DARK,
    light: NOTICE_LIGHT
};
export default NOTICE;
//# sourceMappingURL=palette.schema.notice.js.map